var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3708 12.3765C16.6051 12.6108 16.6051 12.9907 16.3708 13.2251L13.1708 16.4251C12.9992 16.5967 12.7411 16.648 12.5169 16.5551C12.2927 16.4622 12.1465 16.2434 12.1465 16.0008V4.40078C12.1465 4.06941 12.4151 3.80078 12.7465 3.80078C13.0779 3.80078 13.3465 4.06941 13.3465 4.40078V14.5523L15.5222 12.3765C15.7566 12.1422 16.1364 12.1422 16.3708 12.3765Z",
    fill: "#148CEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57647 3.84647C8.80067 3.93934 8.94688 4.15812 8.94688 4.4008V16.0008C8.94688 16.3322 8.67823 16.6008 8.34688 16.6008C8.01549 16.6008 7.74688 16.3322 7.74688 16.0008V5.84932L5.57114 8.02507C5.33683 8.25936 4.95692 8.25936 4.72261 8.02507C4.4883 7.79073 4.4883 7.41086 4.72261 7.17652L7.92261 3.97654C8.09421 3.80494 8.35226 3.7536 8.57647 3.84647Z",
    fill: "#148CEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78119 8.3665C4.46877 8.05407 4.46877 7.54753 4.78119 7.23514L7.98118 4.03512C8.21 3.80632 8.55406 3.73788 8.853 3.8617C9.15195 3.98553 9.34688 4.27723 9.34688 4.60081V15.8008C9.34688 16.2426 8.9887 16.6008 8.54686 16.6008C8.10507 16.6008 7.74689 16.2426 7.74689 15.8008V6.53218L5.91257 8.3665C5.60014 8.67889 5.09361 8.67889 4.78119 8.3665Z",
    fill: "#148CEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3118 12.0351C16.6242 12.3475 16.6242 12.8541 16.3118 13.1664L13.1118 16.3665C12.883 16.5953 12.5389 16.6637 12.24 16.5399C11.941 16.416 11.7461 16.1243 11.7461 15.8008V4.60078C11.7461 4.15896 12.1043 3.80078 12.5461 3.80078C12.9879 3.80078 13.3461 4.15896 13.3461 4.60078V13.8694L15.1804 12.0351C15.4928 11.7227 15.9994 11.7227 16.3118 12.0351Z",
    fill: "#148CEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.429774288954f75944be554d378a3a6f.svg";
export { ForwardRef as ReactComponent };